<script setup lang="ts"></script>
<template>
	<svg class="svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M5.60683 7.35627C5.8222 7.12962 6.17793 7.12962 6.39331 7.35627L10.001 11.1529L13.6068 7.35633C13.8222 7.12967 14.178 7.12962 14.3934 7.35627L14.5326 7.50281C14.7393 7.7203 14.7398 8.06714 14.5298 8.28514L10.3924 12.6412C10.177 12.8679 9.82125 12.8679 9.60587 12.6413L5.46757 8.28422C5.26083 8.06659 5.26079 7.72043 5.46757 7.50282L5.60683 7.35627Z"
			fill="#5D596C" />
	</svg>
</template>
